<div [attr.data-testid]="'image-container'">
  <a [style.padding-bottom.%]="imageHeight" [attr.data-testid]="'image-link'">
    @if (data.url) {
      <span
        [style.background-image]="'url(' + (data.url | imageType) + ')'"
        [style.background-color]="data['backgroundColor']"
        [attr.data-testid]="'image-content'"
      >
      </span>
    }
  </a>
</div>

@if (hasShareAction(data)) {
  <ms-share-preview
    [messageId]="data.action['messageId']"
    [shareCurrentMessage]="data.action['shareCurrentMessage']"
    [package]="flexEditorService.package"
    class="absolute right-0 top-1/2 -translate-y-1/2"
  ></ms-share-preview>
}
